/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Chart";
        const ALLOWED_DATA_INTERPRETERS = ['csv', 'json', 'doclist', 'objectlist', 'dockeys', 'objectattributes'];
        const DEFAULT_COLOUR_MAP_KEY = "[[DEFAUL]]";
        class ChartWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("ChartWidgetTypeClass.createInstance()");
                    return new ChartWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("ChartWidgetTypeClass._storeHtml()");
                    ChartWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ChartWidgetTypeClass::constructor");
                this._allowedOnLogon = false;
                if (ChartWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Chart/chart.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.ChartWidgetTypeClass = ChartWidgetTypeClass;
        class ChartWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._componentContainer = null;
                this._refreshButton = null;
                this._chart = null;
                this._map = null;
                this._cfg = null;
                this._configGood = true; // Assume a good config until breakage detected
                this._pullSources = 0; // Count of data sources requiring instance to request data
                this._pushSources = []; // Flagged messages we need to respond to
                this._nullEntryLabel = null;
                this._refreshTriggers = null;
                this.presentInstance = () => {
                    this._log.info("ChartWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = ChartWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._componentContainer = this._container.querySelector('#chartComponent');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#chartWidgetTitle'), 'STR_WPT_CHART_WIDGET');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._refreshButton = this._container.querySelector('#chartReload');
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    this._sanityCheckConfiguration();
                    if (this._cfg.hasOwnProperty('Height')) {
                        this._componentContainer.style.position = 'relative';
                        this._componentContainer.style.maxHeight = this._cfg.Height + "px";
                        this._componentContainer.style.minHeight = this._cfg.Height + "px";
                    }
                    // Set some sensibel defaults
                    if (this._cfg.hasOwnProperty('RefreshTriggers') && this._cfg.RefreshTriggers && (this._cfg.RefreshTriggers.length > 0))
                        this._refreshTriggers = this._cfg.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    this._nullEntryLabel = this._core.Locale.getTranslation('STR_WPT_NULL_SERIES_LABEL');
                    // Create the actual chart component
                    if (this._cfg.hasOwnProperty('ChartType') && (this._cfg.ChartType == 'googlemap')) {
                        if (this._cfg.hasOwnProperty('MapConfig') && (this._cfg.MapConfig != null)) {
                            this._map = new Widgets.ComponentGoogleMap(this._core, this._componentContainer, this, this._cfg.MapConfig);
                            this._map.present();
                        }
                        else
                            console.error("Unable to instantiate Google Map component without configuration object (with API key).");
                    }
                    else {
                        this._chart = new Widgets.ComponentChart(this._core, this._componentContainer, this, {});
                        this._chart.present();
                    }
                    if ((this._pullSources > 0) && this._configGood) {
                        this._refreshButton.addEventListener('click', this._requestData);
                        this._requestData();
                    }
                    else
                        this._core.Functions.hideElement(this._refreshButton);
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("ChartWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._srcErrorHandler = (src, url, status, message) => {
                    this._log.info("ChartWidgetInstanceClass._callErrorHandler()");
                    src.RequestPending = false;
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._srcFailedHandler = (src, json) => {
                    this._log.info("ChartWidgetInstanceClass._callFailedHandler()");
                    src.RequestPending = false;
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("ChartWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._sanityCheckConfiguration = () => {
                    this._log.info("ChartWidgetInstanceClass._sanityCheckConfiguration()");
                    if (!this._cfg.hasOwnProperty('RefreshPullAfterPush') || (this._cfg.RefreshPullAfterPush == null))
                        this._cfg.RefreshPullAfterPush = false;
                    if (!this._cfg.hasOwnProperty('Sources') || !this._cfg.Sources || (this._cfg.Sources.length == 0)) {
                        this._configGood = false;
                        this.addError('No chart data source(s) configured.');
                    }
                    else {
                        // Check for non-unique IDs
                        let idList = [];
                        // Set flags and any required defaults
                        this._cfg.Sources.forEach(src => {
                            // ensure Ids populated and unique
                            if (!src.hasOwnProperty('Id') || !src.Id || (idList.indexOf(src.Id) > -1)) {
                                this._configGood = false;
                                this.addError('Chart data sources do not have Id set, or identifiers are not unique.');
                                return;
                            }
                            else
                                idList.push(src.Id);
                            // Check our series definitions exist
                            if (!src.hasOwnProperty('Series') || !src.Series || (src.Series.length == 0)) {
                                this._configGood = false;
                                this.addError('One or more chart data sources do not have data series entries defined.');
                                return;
                            }
                            // Check our expected responses and capabilities
                            if (src.SourceType.startsWith('gw')) {
                                src.IsPullRequest = false;
                                if (this._pushSources.indexOf(src.SourceType) == -1)
                                    this._pushSources.push(src.SourceType);
                                if (!src.hasOwnProperty('MessageSources') || !src.MessageSources || (src.MessageSources.length == 0))
                                    src.MessageSources = ['*'];
                                if (!src.hasOwnProperty('MessageSlots') || !src.MessageSlots || (src.MessageSources.length == 0))
                                    src.MessageSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                            }
                            else {
                                src.IsPullRequest = true;
                                this._pullSources = this._pullSources + 1;
                            }
                            // Scan series definitions to determine sanity and whether this source (if direct) is an object or document query
                            let docFound = false;
                            let objFound = false;
                            src.Series.forEach(series => {
                                if (!series.hasOwnProperty('Interpreter') || !series.Interpreter || (ALLOWED_DATA_INTERPRETERS.indexOf(series.Interpreter) == -1)) {
                                    this._configGood = false;
                                    return;
                                }
                                if (src.IsPullRequest) {
                                    if (series.Interpreter.startsWith('doc'))
                                        docFound = true;
                                    else if (series.Interpreter.startsWith('object'))
                                        objFound = true;
                                }
                            });
                            if (docFound && objFound) {
                                this._configGood = false;
                                this.addError('Data source contains clashing interpreters, expects documents AND WorkView objects.');
                                return;
                            }
                            if (docFound)
                                src.IsDocQuery = true;
                            else
                                src.IsDocQuery = false;
                            src.RequestPending = false;
                        });
                    }
                    if (this._pullSources == 0)
                        this._cfg.RefreshPullAfterPush = false;
                };
                // For actively requested data types, initiates the appropriate data pull
                this._requestData = () => {
                    this._log.info("ChartWidgetInstanceClass._requestData()");
                    // Do nothing if we are waiting for an external data push or our configration is broken
                    if ((this._pullSources == 0) || !this._configGood)
                        return;
                    this._core.Functions.showElement(this._loader);
                    // Pull all the remote sources
                    this._cfg.Sources.forEach(src => {
                        if (src.IsPullRequest && !src.RequestPending) {
                            // Clear down existing data
                            src.Series.forEach(series => { series.DataMap = null; });
                            // Request data
                            if (typeof src.DataLocation !== 'object') {
                                this._log.trace("Pulling document data from direct URL");
                                let url = this._core.Context.applyAllMacros(src.DataLocation);
                                this._core.Loader.genericServiceCallTextData(url, this._dataDocReceived.bind(this, src), this._srcErrorHandler.bind(this, src));
                                src.RequestPending = true;
                            }
                            else {
                                this._log.trace("Pulling data from OnBase search");
                                let requestSearch = this._core.OBHelper.flexDefinitionToRequest(src.DataLocation);
                                requestSearch.SuppressKeywords = false;
                                let call = (src.IsDocQuery) ? '/Documents.svc/rest/DocumentQuery' : '/WorkView.svc/rest/ObjectQuery';
                                this._core.Loader.genericServiceCallWithData(call, JSON.stringify(requestSearch), this._hitListReceived.bind(this, src), {}, this._srcErrorHandler.bind(this, src), this._srcFailedHandler.bind(this, src));
                                src.RequestPending = true;
                            }
                        }
                    });
                };
                this._hitListReceived = (src, response) => {
                    this._log.info("ChartWidgetInstanceClass._hitListReceived()");
                    // If the source type is document, but we have a hit list, need to get the actual document
                    if (src.SourceType == 'document') {
                        // We might just need the keywords we already have, and/or we might need the content
                        let contentNeeded = false;
                        let keywordSeries = [];
                        src.Series.forEach(series => {
                            if (['csv', 'json', 'xml'].indexOf(series.Interpreter) > -1)
                                contentNeeded = true;
                            if (series.Interpreter == 'dockeys')
                                keywordSeries.push(series);
                        });
                        let docResponse = response;
                        if (docResponse.hasOwnProperty('Documents') && docResponse.Documents.length > 0) {
                            let doc = docResponse.Documents[0];
                            if (contentNeeded) {
                                let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + doc.ItemNum;
                                this._core.Loader.genericServiceCallTextData(url, this._dataDocReceived.bind(this, src), this._callErrorHandler);
                            }
                            keywordSeries.forEach(series => {
                                this._interpretSingleDocKeys(series, doc);
                            });
                        }
                        else {
                            console.warn("Chart widget receieved no data document in hit list");
                            this._core.Functions.hideElement(this._loader);
                        }
                        if (!contentNeeded) {
                            src.RequestPending = false;
                            if (this._isAllExpectedDataAvailable())
                                this._plot();
                        }
                        return;
                    }
                    // Interpret each series
                    src.Series.forEach(series => {
                        if (series.Interpreter == 'doclist') {
                            let docResponse = response;
                            if (docResponse.hasOwnProperty('Documents') && (docResponse.Documents != null))
                                this._interpretDocList(series, docResponse.Documents);
                        }
                        else if (series.Interpreter == 'dockeys') {
                            let docResponse = response;
                            if (docResponse.hasOwnProperty('Documents') && (docResponse.Documents != null) && (docResponse.Documents.length > 0))
                                this._interpretSingleDocKeys(series, docResponse.Documents[0]);
                        }
                        else {
                            let objResponse = response;
                            // Annoying tree to check
                            if (objResponse.hasOwnProperty('FilterResult') && objResponse.FilterResult) {
                                let wvfr = objResponse.FilterResult;
                                if (wvfr.hasOwnProperty('Result') && (wvfr.Result != null)) {
                                    if (series.Interpreter == 'objectlist') {
                                        this._interpretObjList(series, wvfr.Result);
                                    }
                                    else {
                                        // objectattributes
                                        if (wvfr.Result.length > 0)
                                            this._interpretSingleObjectAttributes(series, wvfr.Result[0]);
                                    }
                                }
                            }
                        }
                    });
                    src.RequestPending = false;
                    if (this._isAllExpectedDataAvailable())
                        this._plot();
                };
                this._dataDocReceived = (src, textData) => {
                    this._log.info("ChartWidgetInstanceClass._dataDocReceived()");
                    // Sanity check response
                    if (!textData.hasOwnProperty('ContentText') || !textData.ContentText) {
                        console.error("Chart widget received empty/null data document.");
                        return;
                    }
                    src.Series.forEach(series => {
                        if (series.Interpreter == 'json')
                            this._interpretJSONData(series, JSON.parse(textData.ContentText));
                        else if (series.Interpreter == 'csv')
                            this._interpretCSVData(series, textData.ContentText);
                        else if (series.Interpreter == 'xml')
                            this._interpretXMLData(series, textData.ContentText);
                    });
                    src.RequestPending = false;
                    if (this._isAllExpectedDataAvailable())
                        this._plot();
                };
                this._interpretSingleDocKeys = (series, doc) => {
                    this._log.info("ChartWidgetInstanceClass._interpretSingleDocKeys()");
                    if (!doc)
                        return;
                    series.DataMap = {};
                    // Use a counter here for our keys, so they are sortable
                    let counter = 0;
                    series.Extractors.forEach(extractor => {
                        if (extractor.Method == 'point') {
                            // We can really only operate with one-offs
                            let values = this._core.OBHelper.GetAllKeywordValues(doc, extractor.Locator);
                            if (values.length == 1) {
                                series.DataMap[extractor.Name] = values[0];
                            }
                            else if (values.length > 1) {
                                if (extractor.hasOwnProperty('MultiplePolicy') && extractor.MultiplePolicy && (extractor.MultiplePolicy == 'sum')) {
                                    let sum = 0;
                                    values.forEach(v => {
                                        sum = sum + Number(v);
                                    });
                                    series.DataMap[extractor.Name] = sum;
                                }
                                else
                                    series.DataMap[extractor.Name] = values[0];
                            }
                            else {
                                if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                    series.DataMap[extractor.Name] = null;
                                }
                            }
                        }
                        else if (extractor.Method == 'pointarray') {
                            let values = this._core.OBHelper.GetAllKeywordValues(doc, extractor.Locator);
                            if (values.length == 0) {
                                if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                    counter++;
                                    series.DataMap[this._core.Helper.zeroPad(counter, 6)] = 0;
                                }
                            }
                            else {
                                if (extractor.hasOwnProperty('MultiplePolicy') && extractor.MultiplePolicy && (extractor.MultiplePolicy == 'first'))
                                    values = [values.shift()];
                                values.forEach(val => {
                                    counter++;
                                    series.DataMap[this._core.Helper.zeroPad(counter, 6)] = val;
                                });
                            }
                        }
                    });
                };
                this._interpretSingleObjectAttributes = (series, obj) => {
                    this._log.info("ChartWidgetInstanceClass._interpretSingleObjectAttributes()");
                    if (!obj)
                        return;
                    series.DataMap = {};
                    series.Extractors.forEach(extractor => {
                        if (extractor.Method == 'point') {
                            // We can really only operate with one-offs
                            let value = this._core.OBHelper.GetObjectAttributeValue(obj, extractor.Locator);
                            if (value)
                                series.DataMap[extractor.Name] = value;
                            else {
                                if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                    series.DataMap[extractor.Name] = value;
                                }
                            }
                        }
                    });
                };
                this._interpretDocList = (series, list) => {
                    this._log.info("ChartWidgetInstanceClass._interpretDocList()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Aggregating data from ${list.length} document records.`);
                    }
                    // Set our map to empty
                    series.DataMap = {};
                    // Use a counter here for our keys, so they are sortable
                    let counter = 0;
                    series.Extractors.forEach(extractor => {
                        let nullLabel = (extractor.hasOwnProperty('NullLabel') && extractor.NullLabel) ? extractor.NullLabel : this._nullEntryLabel;
                        if (extractor.Method == 'aggregate') {
                            list.forEach(doc => {
                                let values = this._core.OBHelper.GetAllKeywordValues(doc, extractor.Locator);
                                if (values.length == 0) {
                                    if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        if (Object.keys(series.DataMap).indexOf(nullLabel) == -1)
                                            series.DataMap[nullLabel] = 1;
                                        else
                                            series.DataMap[nullLabel] = series.DataMap[nullLabel] + 1;
                                    }
                                }
                                else {
                                    if (extractor.hasOwnProperty('MultiplePolicy') && extractor.MultiplePolicy && (extractor.MultiplePolicy == 'first'))
                                        values = [values.shift()];
                                    values.forEach(val => {
                                        if (Object.keys(series.DataMap).indexOf(val) == -1)
                                            series.DataMap[val] = 1;
                                        else
                                            series.DataMap[val] = series.DataMap[val] + 1;
                                    });
                                }
                            });
                        }
                        else if (extractor.Method == 'pointarray') {
                            list.forEach(doc => {
                                let values = this._core.OBHelper.GetAllKeywordValues(doc, extractor.Locator);
                                if (values.length == 0) {
                                    if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        counter++;
                                        series.DataMap[this._core.Helper.zeroPad(counter, 6)] = 0;
                                    }
                                }
                                else {
                                    if (extractor.hasOwnProperty('MultiplePolicy') && extractor.MultiplePolicy && (extractor.MultiplePolicy == 'first'))
                                        values = [values.shift()];
                                    values.forEach(val => {
                                        counter++;
                                        series.DataMap[this._core.Helper.zeroPad(counter, 6)] = val;
                                    });
                                }
                            });
                        }
                        else {
                            // Right now it must be a point - not many options here
                            if (extractor.Locator == '[[ROW_COUNT]]')
                                series.DataMap[this._core.Locale.getTranslation('STR_WPT_ROW_COUNT')] = list.length;
                        }
                    });
                };
                this._interpretObjList = (series, list) => {
                    this._log.info("ChartWidgetInstanceClass._interpretObjList()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Aggregating data from ${list.length} document records.`);
                    }
                    // Set our map to empty
                    series.DataMap = {};
                    // Use a counter here for our keys, so they are sortable
                    let counter = 0;
                    series.Extractors.forEach(extractor => {
                        let nullLabel = (extractor.hasOwnProperty('NullLabel') && extractor.NullLabel) ? extractor.NullLabel : this._nullEntryLabel;
                        if (extractor.Method == 'aggregate') {
                            list.forEach(obj => {
                                let value = this._core.OBHelper.GetObjectAttributeValue(obj, extractor.Locator);
                                if (!value) {
                                    if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        if (Object.keys(series.DataMap).indexOf(nullLabel) == -1)
                                            series.DataMap[nullLabel] = 1;
                                        else
                                            series.DataMap[nullLabel] = series.DataMap[nullLabel] + 1;
                                    }
                                }
                                else {
                                    if (Object.keys(series.DataMap).indexOf(value) == -1)
                                        series.DataMap[value] = 1;
                                    else
                                        series.DataMap[value] = series.DataMap[value] + 1;
                                }
                            });
                        }
                        else if (extractor.Method == 'pointarray') {
                            list.forEach(obj => {
                                counter++;
                                let value = this._core.OBHelper.GetObjectAttributeValue(obj, extractor.Locator);
                                if (!value) {
                                    if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        series.DataMap[this._core.Helper.zeroPad(counter, 6)] = 0;
                                    }
                                }
                                else
                                    series.DataMap[this._core.Helper.zeroPad(counter, 6)] = value;
                            });
                        }
                        else {
                            // Right now it must be a point - not many options here
                            if (extractor.Locator == '[[ROW_COUNT]]')
                                series.DataMap[this._core.Locale.getTranslation('STR_WPT_ROW_COUNT')] = list.length;
                        }
                    });
                };
                this._interpretJSONData = (series, json) => {
                    this._log.info("ChartWidgetInstanceClass._interpretJSONData()");
                    series.DataMap = {};
                    let counter = 0;
                    series.Extractors.forEach(extractor => {
                        let nullLabel = (extractor.hasOwnProperty('NullLabel') && extractor.NullLabel) ? extractor.NullLabel : this._nullEntryLabel;
                        if (extractor.Method == 'aggregate') {
                            //For JSON aggregation we have a format <root object>:<iteration type>:<child path>
                            let locators = extractor.Locator.split(':');
                            if ((locators.length == 3) && (['index', 'key'].indexOf(locators[1]) > -1)) {
                                let root = (locators[0] == '[[ROOT]]') ? json : this._core.Functions.mapObject(locators[0], json);
                                let items = [];
                                // Use iterator of choice to pull objects into array
                                if (locators[1] == 'index')
                                    for (let i = 0; i < root.length; i++) {
                                        items.push(root[i]);
                                    }
                                else
                                    Object.keys(root).forEach(key => { items.push[root[key]]; });
                                // Loop and aggregate
                                items.forEach(item => {
                                    let value = this._core.Functions.mapObject(locators[2], item);
                                    if (value == null) {
                                        if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                            if (Object.keys(series.DataMap).indexOf(nullLabel) == -1)
                                                series.DataMap[nullLabel] = 1;
                                            else
                                                series.DataMap[nullLabel] = series.DataMap[nullLabel] + 1;
                                        }
                                    }
                                    else {
                                        if (Object.keys(series.DataMap).indexOf(value) == -1)
                                            series.DataMap[value] = 1;
                                        else
                                            series.DataMap[value] = series.DataMap[value] + 1;
                                    }
                                });
                            }
                            else {
                                console.warn(`JSON aggregate locator '${extractor.Locator}' is not valid.`);
                            }
                        }
                        else if (extractor.Method == 'pointarray') {
                            // Use a counter here for our keys, so they are sortable
                            let locators = extractor.Locator.split(':');
                            if ((locators.length == 3) && (['index', 'key'].indexOf(locators[1]) > -1)) {
                                let root = (locators[0] == '[[ROOT]]') ? json : this._core.Functions.mapObject(locators[0], json);
                                let items = [];
                                // Use iterator of choice to pull objects into array
                                if (locators[1] == 'index')
                                    for (let i = 0; i < root.length; i++) {
                                        items.push(root[i]);
                                    }
                                else
                                    Object.keys(root).forEach(key => { items.push[root[key]]; });
                                // Loop and store
                                items.forEach(item => {
                                    counter++;
                                    let value = this._core.Functions.mapObject(locators[2], item);
                                    if (value == null) {
                                        if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                            counter++;
                                            series.DataMap[this._core.Helper.zeroPad(counter, 6)] = 0;
                                        }
                                    }
                                    else
                                        series.DataMap[this._core.Helper.zeroPad(counter, 6)] = value;
                                });
                            }
                            else {
                                console.warn(`JSON aggregate locator '${extractor.Locator}' is not valid.`);
                            }
                        }
                        else {
                            // Method == 'point'
                            let value = this._core.Functions.mapObject(extractor.Locator, json);
                            if (value != null)
                                series.DataMap[extractor.Name] = value;
                            else {
                                if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                    series.DataMap[extractor.Name] = value;
                                }
                            }
                        }
                    });
                };
                this._interpretCSVData = (series, csv) => {
                    this._log.info("ChartWidgetInstanceClass._interpretCSVData()");
                    // TODO: Determine whether to code this internally or grab a parsing library
                };
                this._interpretXMLData = (series, xml) => {
                    this._log.info("ChartWidgetInstanceClass._interpretXMLData()");
                };
                this._getDataSetColumnIndex = (locator, data) => {
                    this._log.info("ChartWidgetInstanceClass._getDataSetColumnIndex()");
                    if (!locator)
                        return -1;
                    // Expect "[[COLUMN_NAME]]:MyColumn" or "[[COLUMN_INDEX]]:5"
                    if (locator.startsWith('[[COLUMN_NAME]]:')) {
                        let chunks = locator.split(':');
                        if (chunks.length > 1)
                            return (data.Columns.indexOf(chunks[1]));
                    }
                    else if (locator.startsWith('[[COLUMN_INDEX]]:')) {
                        let chunks = locator.split(':');
                        if (chunks.length > 1)
                            return Number(chunks[1]);
                    }
                    return -1;
                };
                this._interpretPublishedDataSet = (series, data) => {
                    this._log.info("ChartWidgetInstanceClass._interpretPublishedDataSet()");
                    // Set our map to empty
                    series.DataMap = {};
                    // Loop with iterator so we can 'continue'
                    for (let exCounter = 0; exCounter < series.Extractors.length; exCounter++) {
                        let extractor = series.Extractors[exCounter];
                        // Pull the column index from our locator
                        let colIndex = this._getDataSetColumnIndex(extractor.Locator, data);
                        if (colIndex < 0)
                            continue;
                        let nullLabel = (extractor.hasOwnProperty('NullLabel') && extractor.NullLabel) ? extractor.NullLabel : this._nullEntryLabel;
                        // Pull data depending on extractor method
                        if (extractor.Method == 'aggregate') {
                            data.RowData.forEach(row => {
                                let value = (row[colIndex] != null) ? row[colIndex].toString() : null;
                                if (!value) {
                                    if (series.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        if (Object.keys(series.DataMap).indexOf(nullLabel) == -1)
                                            series.DataMap[nullLabel] = 1;
                                        else
                                            series.DataMap[nullLabel] = series.DataMap[nullLabel] + 1;
                                    }
                                }
                                else {
                                    if (Object.keys(series.DataMap).indexOf(value) == -1)
                                        series.DataMap[value] = 1;
                                    else
                                        series.DataMap[value] = series.DataMap[value] + 1;
                                }
                            });
                        }
                        else if (extractor.Method == 'pointarray') {
                            // Use a counter here for our keys, so they are sortable
                            let counter = 0;
                            data.RowData.forEach(row => {
                                let value = (row[colIndex] != null) ? row[colIndex] : null;
                                if (value == null) {
                                    if (extractor.hasOwnProperty('NullPolicy') && extractor.NullPolicy && (extractor.NullPolicy == 'retain')) {
                                        counter++;
                                        series.DataMap[this._core.Helper.zeroPad(counter, 6)] = 0;
                                    }
                                }
                                else {
                                    counter++;
                                    series.DataMap[this._core.Helper.zeroPad(counter, 6)] = value;
                                }
                            });
                        }
                        else {
                            // Right now it must be a point - not many options here
                            if (extractor.Locator == '[[ROW_COUNT]]')
                                series.DataMap[this._core.Locale.getTranslation('STR_WPT_ROW_COUNT')] = data.RowData.length;
                        }
                    }
                };
                this._isAllExpectedDataAvailable = () => {
                    this._log.info("ChartWidgetInstanceClass._isAllExpectedDataAvailable()");
                    let dataAvailable = true;
                    this._cfg.Sources.forEach(src => {
                        // TODO - Ensure RequestPending only cancelled after all series are interpreted.
                        if (src.RequestPending)
                            dataAvailable = false;
                    });
                    return dataAvailable;
                };
                this._plot = () => {
                    if (this._cfg.hasOwnProperty('ChartType') && (this._cfg.ChartType == 'googlemap'))
                        this._assembleAndExecuteMapRequest();
                    else
                        this._assembleAndExecuteChartRequest();
                };
                this._assembleAndExecuteMapRequest = () => {
                    this._log.info("ChartWidgetInstanceClass._assembleAndExecuteMapRequest()");
                    let pins = [];
                    // Insert all populated series with the correct tags - loop with for so we can jump out
                    for (let i = 0; i < this._cfg.Sources.length; i++) {
                        let src = this._cfg.Sources[i];
                        // Pull the three required series
                        let labels = src.Series.find(s => (s.Label == 'MapLabels'));
                        let longitudes = src.Series.find(s => (s.Label == 'MapLongitudes'));
                        let latitudes = src.Series.find(s => (s.Label == 'MapLatitudes'));
                        // If no series, or they don't match, jump out
                        if (!labels || !longitudes || !latitudes) {
                            console.error("Map data for chart widget does not contain all required series ('MapLabels', 'MapLongitudes', 'MapLatitudes')");
                            return;
                        }
                        let labelKeys = Object.keys(labels.DataMap);
                        let longKeys = Object.keys(longitudes.DataMap);
                        let latKeys = Object.keys(latitudes.DataMap);
                        if ((labelKeys.length != longKeys.length) || (latKeys.length != longKeys.length)) {
                            console.error("Map data series for chart widget do not have matching lengths ('MapLabels', 'MapLongitudes', 'MapLatitudes')");
                            return;
                        }
                        // Sort post-hoc because we don't want to disrupt whatever Object.keys is doing by running sort in place
                        labelKeys.sort();
                        longKeys.sort();
                        latKeys.sort();
                        // Now loop and combine arrays to create map pins
                        for (let j = 0; j < labelKeys.length; j++) {
                            if ((latitudes.DataMap[latKeys[j]] != null) && (longitudes.DataMap[longKeys[j]] != null)) {
                                let lat = Number(latitudes.DataMap[latKeys[j]]);
                                let long = Number(longitudes.DataMap[longKeys[j]]);
                                if ((lat != NaN) && (long != NaN))
                                    pins.push({ Label: labels.DataMap[labelKeys[j]], Latitude: lat, Longitude: long });
                            }
                        }
                    }
                    // Hide the loader to free space before requesting draw
                    this._core.Functions.hideElement(this._loader);
                    this._map.drawMap(pins);
                };
                this._assembleAndExecuteChartRequest = () => {
                    this._log.info("ChartWidgetInstanceClass._assembleAndExecuteChartRequest()");
                    // Need the chart data for out output
                    let chartData = this._createMainChartConfig();
                    // Insert all populated series
                    this._cfg.Sources.forEach(src => {
                        src.Series.forEach(series => {
                            let populateLabels = (chartData.data.labels.length == 0);
                            if (series.DataMap) {
                                let dataSeries = { data: [] };
                                let counter = 0;
                                for (let mapKey in series.DataMap) {
                                    counter++;
                                    dataSeries.data.push(series.DataMap[mapKey]);
                                    // Append more labels from longer series to the end so we have the correct number - this may have horrible results but seems safest
                                    if (populateLabels && (chartData.data.labels.length < counter))
                                        chartData.data.labels.push(mapKey);
                                }
                                chartData.data.datasets.push(dataSeries);
                                this._setSeriesColours(dataSeries, series);
                                if (series.hasOwnProperty('Label') && series.Label)
                                    dataSeries.label = this._core.Locale.getTranslation(series.Label);
                            }
                        });
                    });
                    // Hide the loader to free space before requesting draw
                    this._core.Functions.hideElement(this._loader);
                    this._chart.drawChart(chartData);
                };
                this._createMainChartConfig = () => {
                    this._log.info("ChartWidgetInstanceClass._creatMainChartConfig()");
                    // Support warning if necessary
                    if (Widgets.SUPPORTED_CHART_TYPES.indexOf(this._cfg.ChartType) == -1)
                        console.warn(`Requested chart type '${this._cfg.ChartType}' may work, but is currently unsupported.`);
                    let chartConf = {
                        type: this._cfg.ChartType,
                        data: {
                            datasets: [],
                            labels: []
                        }
                    };
                    // Pull custom options and default plugins if necessary
                    if (this._cfg.hasOwnProperty('ChartOptions') && this._cfg.ChartOptions)
                        chartConf.options = this._cfg.ChartOptions;
                    else
                        chartConf.options = { responsive: true, maintainAspectRatio: false };
                    if (!chartConf.options.hasOwnProperty('plugins'))
                        chartConf.options.plugins = {};
                    // If no plugins options, default and set passed high-level items
                    if (this._cfg.hasOwnProperty('ChartTitle') && this._cfg.ChartTitle) {
                        if (chartConf.options.plugins.hasOwnProperty('title') && chartConf.options.plugins.title) {
                            // Insert from here even if title set, to allow translation
                            chartConf.options.plugins.title.text = this._core.Locale.getTranslation(this._cfg.ChartTitle);
                        }
                        else
                            chartConf.options.plugins.title = { display: true, text: this._core.Locale.getTranslation(this._cfg.ChartTitle) };
                    }
                    if (this._cfg.hasOwnProperty('ChartLegendPosition') && this._cfg.ChartLegendPosition)
                        chartConf.options.plugins.legend = { display: true, position: this._cfg.ChartLegendPosition };
                    else
                        chartConf.options.plugins.legend = { display: false };
                    return chartConf;
                };
                this._setSeriesColours = (dataset, series) => {
                    this._log.info("ChartWidgetInstanceClass._setSeriesColours()");
                    if (series.hasOwnProperty('BackgroundColourMap') && series.BackgroundColourMap) {
                        dataset.backgroundColor = [];
                        let dataKeys = Object.keys(series.DataMap);
                        let mapKeys = Object.keys(series.BackgroundColourMap);
                        let counter = 0;
                        dataKeys.forEach(dataKey => {
                            if (mapKeys.indexOf(dataKey) > -1)
                                dataset.backgroundColor.push(series.BackgroundColourMap[dataKey]);
                            else {
                                // Default behaviour for non-set maps
                                if (mapKeys.indexOf(DEFAULT_COLOUR_MAP_KEY) > -1)
                                    dataset.backgroundColor.push(series.BackgroundColourMap[DEFAULT_COLOUR_MAP_KEY]);
                                else {
                                    counter++;
                                    dataset.backgroundColor.push(Widgets.DEFAULT_CHART_COLOURS[counter % Widgets.DEFAULT_CHART_COLOURS.length]);
                                }
                            }
                        });
                    }
                    else if (series.hasOwnProperty('BackgroundColours') && series.BackgroundColours && (series.BackgroundColours.length > 0)) {
                        dataset.backgroundColor = [];
                        for (let i = 0; i < dataset.data.length; i++) {
                            dataset.backgroundColor.push(series.BackgroundColours[i % series.BackgroundColours.length]);
                        }
                    }
                    if (series.hasOwnProperty('BorderColours') && series.BorderColours && (series.BorderColours.length > 0)) {
                        dataset.borderColor = [];
                        for (let i = 0; i < dataset.data.length; i++) {
                            dataset.borderColor.push(series.BorderColours[i % series.BorderColours.length]);
                        }
                    }
                    if (series.hasOwnProperty('BorderWidth') && (series.BorderWidth != null))
                        dataset.borderWidth = series.BorderWidth;
                };
                this._validSourcesForMessage = (sourceType, context) => {
                    this._log.info("ChartWidgetInstanceClass._messageSourceAccepted()");
                    let config = this._config;
                    let validSources = [];
                    for (let i = 0; i < config.Sources.length; i++) {
                        let source = config.Sources[i];
                        if (source.SourceType != sourceType)
                            continue;
                        if ((source.MessageSources.indexOf('*') > -1) || ((context.ActivatingWidget) && (source.MessageSources.indexOf(context.ActivatingWidget.getId()) > -1))) {
                            if (sourceType == 'gwdocument') {
                                if (source.MessageSlots.some(slot => (context.Slots.indexOf(slot) > -1)))
                                    validSources.push(source);
                            }
                            else
                                validSources.push(source);
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`${validSources.length} sources accepted to be processed.`);
                    }
                    return validSources;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ChartWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._cfg = config;
            }
            activate(context) {
                this._log.info("ChartWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                let config = this._config;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DATASET_PUBLISHED:
                        if (this._pushSources.indexOf('gwdataset') > -1) {
                            let plotRequired = false;
                            let valid = this._validSourcesForMessage('gwdataset', context);
                            valid.forEach(source => {
                                source.Series.forEach(series => {
                                    if (series.Interpreter == 'gwdataset') {
                                        this._interpretPublishedDataSet(series, context.PrimaryContext);
                                        plotRequired = true;
                                    }
                                });
                            });
                            if (this._cfg.RefreshPullAfterPush)
                                this._requestData();
                            else if (plotRequired)
                                this._plot();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_DEFINITION:
                        let valid = this._validSourcesForMessage('gwquery', context);
                        valid.forEach(source => {
                            let call = '/Documents.svc/rest/DocumentQuery';
                            source.Series.forEach(series => { if (series.Interpreter == 'objectlist')
                                call = '/WorkView.svc/rest/ObjectQuery'; });
                            let requestSearch = this._core.OBHelper.flexDefinitionToRequest(context.PrimaryContext);
                            requestSearch.SuppressKeywords = false;
                            source.RequestPending = true;
                            this._core.Loader.genericServiceCallWithData(call, JSON.stringify(requestSearch), this._hitListReceived.bind(this, ""), {}, this._callErrorHandler, this._callFailedHandler);
                        });
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS:
                        if (this._pushSources.indexOf('gwhitlist') > -1) {
                            this._validSourcesForMessage('gwhitlist', context);
                            let plotRequired = false;
                            let contentRequired = false;
                            let valid = this._validSourcesForMessage('gwhitlist', context);
                            valid.forEach(source => {
                                let makeContentRequest = false;
                                source.Series.forEach(series => {
                                    if (series.Interpreter == 'doclist') {
                                        this._interpretDocList(series, context.PrimaryContext);
                                        plotRequired = true;
                                    }
                                    else if (series.Interpreter == 'dockeys') {
                                        if (context.PrimaryContext && (context.PrimaryContext.length > 0)) {
                                            this._interpretSingleDocKeys(series, context.PrimaryContext[0]);
                                            plotRequired = true;
                                        }
                                    }
                                    else if (['csv', 'json', 'xml'].indexOf(series.Interpreter) > -1)
                                        makeContentRequest = true;
                                });
                                // Might have interpreters which need content
                                if (makeContentRequest) {
                                    source.RequestPending = true;
                                    let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + context.PrimaryContext[0].ItemNum;
                                    this._core.Loader.genericServiceCallTextData(url, this._dataDocReceived.bind(this, source), this._callErrorHandler);
                                    // Do not immediately plot
                                    contentRequired = true;
                                }
                            });
                            if (plotRequired && !contentRequired)
                                this._plot();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        if (this._pushSources.indexOf('gwdocument') > -1) {
                            let plotRequired = false;
                            let contentRequired = false;
                            let valid = this._validSourcesForMessage('gwdocument', context);
                            valid.forEach(source => {
                                let makeContentRequest = false;
                                source.Series.forEach(series => {
                                    if (series.Interpreter == 'dockeys') {
                                        this._interpretSingleDocKeys(series, context.PrimaryContext);
                                        plotRequired = true;
                                    }
                                    if (['csv', 'json', 'xml'].indexOf(series.Interpreter) > -1)
                                        makeContentRequest = true;
                                });
                                // Might have interpreters which need content
                                if (makeContentRequest) {
                                    source.RequestPending = true;
                                    let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + context.PrimaryContext[0].ItemNum;
                                    this._core.Loader.genericServiceCallTextData(url, this._dataDocReceived.bind(this, source), this._callErrorHandler);
                                    // Do not immediately plot
                                    contentRequired = true;
                                }
                            });
                            if (plotRequired && !contentRequired)
                                this._plot();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED:
                        // When WV moved to slots, add true parameter to _messageSourceAccepted
                        if ((this._pushSources.indexOf('gwobject') > -1) && this._validSourcesForMessage('gwobject', context)) {
                            //this._interpretDocList(context.PrimaryContext);
                        }
                        if (this._pushSources.indexOf('gwobject') > -1) {
                            let plotRequired = false;
                            let valid = this._validSourcesForMessage('gwobject', context);
                            valid.forEach(source => {
                                source.Series.forEach(series => {
                                    if (series.Interpreter == 'objectattributes') {
                                        this._interpretSingleObjectAttributes(series, context.PrimaryContext);
                                        plotRequired = true;
                                    }
                                });
                            });
                            if (this._cfg.RefreshPullAfterPush)
                                this._requestData();
                            else if (plotRequired)
                                this._plot();
                        }
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._requestData();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        ChartWidgetInstanceClass.HtmlData = null;
        Widgets.ChartWidgetInstanceClass = ChartWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
